import React, { FunctionComponent } from "react"

interface DoodleColorIconProps {}

const DoodleColorIcon: FunctionComponent<DoodleColorIconProps> = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.78129 17.2693C4.97777 17.0676 4.16295 17.5556 3.96133 18.3591C3.75972 19.1626 4.24766 19.9774 5.05118 20.1791L5.78129 17.2693ZM21.9415 13.933C22.304 13.1881 21.9939 12.2904 21.249 11.928C20.5041 11.5655 19.6064 11.8756 19.2439 12.6205L21.9415 13.933ZM5.05118 20.1791C7.48093 20.7887 10.7351 21.099 13.8652 20.3401C17.0439 19.5694 20.1181 17.6808 21.9415 13.933L19.2439 12.6205C17.8822 15.4191 15.6371 16.8235 13.1583 17.4246C10.6309 18.0374 7.88943 17.7982 5.78129 17.2693L5.05118 20.1791Z" fill="#FFC200"/>
<circle cx="6.25" cy="7.25" r="3.75" fill="#FFC200"/>
<circle cx="17.75" cy="7.25" r="3.75" fill="#FFC200"/>
<circle cx="12" cy="7" r="4.25" fill="#FFC200" stroke="white"/>
</svg>
  )
}

export default DoodleColorIcon
